module.exports = __webpack_public_path__ + "static/media/s_sf_3.754e8533.png";